import"./SonosImage.css.ts.vanilla.css";var r="_1arxf8x2";export{r as imageContainer};
